import * as React from 'react';
import global from '../css/Global.module.css';

function SideBySideContentHeroBlock({
    title,
    leftImg,
    rightImg,
    leftCaption1,
    leftCaption2,
    leftHeading,
    leftBody,
    rightHeading,
    rightBody,
    leftAlt = '',
    rightAlt = ''
}) {
    return (
        <section className={global.sideBySideHero}>
            {title && <div className={global.featureH1}><h1>{title}</h1></div>}

            <div className={global.sideBySideHeroInner}>
                <div className={global.sideBySideCol}>
                    <div className={global.sideBySideImage}>
                        <img src={leftImg} alt={leftAlt} />
                    </div>
                    {(leftCaption1 || leftCaption2) && (
                        <div className={global.sideBySideCaptionRow}>
                            {leftCaption1 && <div className={global.sideBySideCaption}>{leftCaption1}</div>}
                            {leftCaption2 && <div className={global.sideBySideCaption}>{leftCaption2}</div>}
                        </div>
                    )}
                    <div className={global.sideBySideTextBlock}>
                        {leftHeading && <div className={global.sideBySideHeading}>{leftHeading}</div>}
                        {leftBody && <div className={global.sideBySideBody}>{leftBody}</div>}
                    </div>
                </div>

                <div className={global.sideBySideCol}>
                    <div className={global.sideBySideImage}>
                        <img src={rightImg} alt={rightAlt} />
                    </div>
                    <div className={global.sideBySideTextBlock}>
                        {rightHeading && <div className={global.sideBySideHeading}>{rightHeading}</div>}
                        {rightBody && <div className={global.sideBySideBody}>{rightBody}</div>}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SideBySideContentHeroBlock;